export const LIVE_BET_ANIMATION_DURATION = 400
